import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Box, Text } from "@mantine/core";
import { useQueryClient } from "@tanstack/react-query";
import styles from "./editLaborFee.module.scss";
import LabourFeeManagement from "@/components/features/ClientOnboarding/LabourFeeManagement/LabourFeeManagement";
import { IconX } from "@tabler/icons-react";
import { RatesQueryKeys } from "@/api/clients/rates/rates.endpoints";

export const Route = createFileRoute("/clients/$id/edit-rates/labor-fee/")({
  component: EditLaborFeeComponent,
});

function EditLaborFeeComponent() {
  const { id: clientId } = Route.useParams() as { id: string };
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleCancel = () => {
    queryClient.invalidateQueries({
      queryKey: RatesQueryKeys.overtimeTripFees,
      refetchType: "all",
    });
    queryClient.invalidateQueries({
      queryKey: RatesQueryKeys.trades,
      refetchType: "all",
    });
    queryClient.invalidateQueries({
      queryKey: RatesQueryKeys.technicianRates,
      refetchType: "all",
    });

    navigate({
      to: `/clients/${clientId}?tab=rates`,
    });
  };
  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <Text className={styles.headerText}>Edit Labor Fee</Text>
        <IconX size={16} onClick={handleCancel} cursor="pointer" />
      </Box>
      <Box className={styles.content}>
        <LabourFeeManagement laborId={clientId} />
      </Box>
    </Box>
  );
}
